(function () {
  'use strict';
  if (window.AUVENNEDesktopPerfectionBound) return;
  window.AUVENNEDesktopPerfectionBound = true;

  var desktop = window.matchMedia('(min-width: 1100px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isSwedish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
  }

  function ui(nl, sv) {
    return isSwedish() ? sv : nl;
  }

  function closestSlide(slides, gallery) {
    var current = 0;
    var distance = Infinity;
    slides.forEach(function (slide, index) {
      var nextDistance = Math.abs(slide.offsetLeft - gallery.scrollLeft);
      if (nextDistance < distance) {
        distance = nextDistance;
        current = index;
      }
    });
    return current;
  }

  function buildProductThumbnails(scope) {
    var root = (scope || document).querySelector('[data-lu-pdp]') || document.querySelector('[data-lu-pdp]');
    if (!root) return;
    var shell = root.querySelector('.lu-pdp__gallery-shell');
    var gallery = root.querySelector('[data-lu-gallery]');
    var existing = shell && shell.querySelector('[data-auv-desktop-thumbs]');

    if (!desktop.matches) {
      if (existing) existing.remove();
      return;
    }

    if (!shell || !gallery || existing) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll(':scope > .lu-media'));
    if (slides.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'auv-pdp-desktop-thumbs';
    nav.setAttribute('data-auv-desktop-thumbs', '');
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', ui('Kies een productbeeld', 'Välj en produktbild'));

    var buttons = slides.map(function (slide, index) {
      var source = slide.querySelector('img');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'auv-pdp-desktop-thumb';
      button.setAttribute('aria-label', ui(
        'Bekijk productbeeld ' + (index + 1) + ' van ' + slides.length,
        'Visa produktbild ' + (index + 1) + ' av ' + slides.length
      ));
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      if (source) {
        var image = document.createElement('img');
        image.src = source.currentSrc || source.src;
        if (source.srcset) image.srcset = source.srcset;
        if (source.sizes) image.sizes = '68px';
        image.alt = '';
        image.loading = index < 3 ? 'eager' : 'lazy';
        image.width = 68;
        image.height = 85;
        button.appendChild(image);
      }

      button.addEventListener('click', function () {
        gallery.scrollTo({
          left: slides[index].offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      });
      nav.appendChild(button);
      return button;
    });

    var updateCurrent = function () {
      var current = closestSlide(slides, gallery);
      buttons.forEach(function (button, index) {
        button.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    };

    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateCurrent();
        ticking = false;
      });
    }, { passive: true });

    shell.insertBefore(nav, gallery);
    updateCurrent();
  }

  function exposeDesktopFilters(scope) {
    var root = (scope || document).querySelector('.lu-collection-body') || document.querySelector('.lu-collection-body');
    if (!root) return;
    var filters = root.querySelector('[data-lu-filters]');
    var toggle = root.querySelector('[data-lu-filter-toggle]');
    if (!filters) return;

    if (desktop.matches) {
      filters.hidden = false;
      filters.setAttribute('data-auv-desktop-filters', 'true');
      if (toggle) {
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (filters.getAttribute('data-auv-desktop-filters') === 'true') {
      filters.hidden = true;
      filters.removeAttribute('data-auv-desktop-filters');
      if (toggle) {
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function run(scope) {
    buildProductThumbnails(scope || document);
    exposeDesktopFilters(scope || document);
  }

  function start() {
    run(document);
    window.requestAnimationFrame(function () { run(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  if (typeof desktop.addEventListener === 'function') {
    desktop.addEventListener('change', function () { run(document); });
  } else if (typeof desktop.addListener === 'function') {
    desktop.addListener(function () { run(document); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });
})();

